export default __webpack_public_path__ + "static/media/duit_now_qr_code.221bc2dd.svg";